@if (loading()) {
  <div class="spinner-overlay">
    <app-spinner size="small"
                 theme="default"
                 [showTrack]="false"/>
  </div>
}
<ng-content select="app-icon"></ng-content>